import config from '@app/config'

import { isBuyerView } from './isBuyerView'

export const isB2BView = () => config.identity.isBackOffice && !isBuyerView()
